import './AtmLink.scss';
import { Link } from "react-router-dom";

const AtmLink = (props) => {
  const className = `
    ${!props.noStyle && !props.inline ? 'atm-link' : ''}
    ${props.inline ? 'atm-link--inline' : ''}
    ${props.className}
  `;

  return (
    <Link className={className} to={props.to} onClick={props.onClick}>
      {props.children}
    </Link>
  )
}

export default AtmLink;